import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import type { PDFDocumentProxy } from "pdfjs-dist";
import styled from "styled-components";
import { Card, CardActions, CardContent, IconButton } from "@material-ui/core";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";

interface IPdfFilePreview {
  file: File | string;
}

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PageControl = styled("div")({
  display: "flex",
  alignItems: "center",
  fontSize: "12px",
  marginLeft: "auto",
  marginRight: "auto",
});

const CustomPdfPreview: React.FC<IPdfFilePreview> = ({ file }) => {
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [renderedPageNumber, setRenderedPageNumber] = useState<number | null>(
    null
  );

  if (!file) {
    return <></>;
  }

  const changePage = (offset: number) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  const previousPage = () => {
    changePage(-1);
  };

  const nextPage = () => {
    changePage(1);
  };

  const onDocumentLoadSuccess = (pdf: any): void => {
    const pdfFile: PDFDocumentProxy = pdf as PDFDocumentProxy;

    setNumPages(pdfFile._pdfInfo.numPages);
    setPageNumber(1);
  };

  const isLoading = renderedPageNumber !== pageNumber;

  return (
    <Card>
      <CardContent>
        <Document
          file={file ? file : undefined}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          {isLoading && renderedPageNumber ? (
            <Page
              width={500}
              key={`page_${renderedPageNumber}`}
              pageNumber={renderedPageNumber}
            />
          ) : (
            <></>
          )}
          <Page
            width={500}
            key={`page_${pageNumber}`}
            pageNumber={pageNumber}
            onRenderSuccess={() => setRenderedPageNumber(pageNumber)}
          />
        </Document>
      </CardContent>
      <CardActions>
        <PageControl>
          <p>
            Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
          </p>
          <IconButton
            aria-label="previous"
            disabled={pageNumber <= 1}
            onClick={previousPage}
          >
            <SkipPreviousIcon />
          </IconButton>
          <IconButton
            aria-label="next"
            disabled={pageNumber >= numPages}
            onClick={nextPage}
          >
            <SkipNextIcon />
          </IconButton>
        </PageControl>
      </CardActions>
    </Card>
  );
};

export default CustomPdfPreview;
